import * as styles from './Loader.module.scss';

import cn from 'classnames';
import React from "react";

export type LoaderProps = {
  className?: string;
  isAbsolute?: boolean;
} & React.HTMLProps<HTMLSpanElement>;

const Loader: React.FC<LoaderProps> = ({ className, isAbsolute, ...props }) => (
  <span className={cn(styles.loader, isAbsolute && styles.loader_absolute, className)} {...props}>
    <span className={styles.loader__dot} />
  </span>
);

export default React.memo(Loader);
